import { render, staticRenderFns } from "./WorkPlanAdd.vue?vue&type=template&id=5fb8d46b&scoped=true&"
import script from "./WorkPlanAdd.vue?vue&type=script&lang=js&"
export * from "./WorkPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb8d46b",
  null
  
)

export default component.exports